import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-despachos',
  template: require('./despachos.component.html')
})
export class DespachosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/despachos.component.ts
 **/